/* Filter topic links locally; Shopify retains article filtering and pagination. */
(() => {
  if (customElements.get('mm-blog-topics')) return;
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[-_–—]/g, ' ').trim();
  customElements.define('mm-blog-topics', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.details = this.querySelector('details');
      this.input = this.querySelector('[data-topic-input]');
      if (!this.details || !this.input) return;
      this.connected = true;
      this.summary = this.details.querySelector('summary');
      this.clear = this.querySelector('[data-topic-clear]');
      this.count = this.querySelector('[data-topic-count]');
      this.empty = this.querySelector('[data-topic-empty]');
      this.links = [...this.querySelectorAll('[data-topic-link]')];
      this.onInput = () => this.filter();
      this.onClear = () => { this.input.value = ''; this.filter(); this.input.focus(); };
      this.onToggle = () => { if (this.details.open) this.input.focus(); };
      this.onKey = event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.details.open = false;
          this.summary.focus();
        } else if (event.key === 'ArrowDown' && event.target === this.input) {
          const first = this.links.find(link => !link.hidden);
          if (first) { event.preventDefault(); first.focus(); }
        }
      };
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('search', this.onInput);
      this.clear.addEventListener('click', this.onClear);
      this.details.addEventListener('toggle', this.onToggle);
      this.addEventListener('keydown', this.onKey);
      this.querySelector('[data-topic-search]').hidden = false;
      this.filter();
    }
    filter() {
      const words = normalize(this.input.value).split(/\s+/).filter(Boolean);
      let count = 0;
      this.links.forEach(link => {
        const matches = words.every(word => normalize(link.dataset.topicName || link.textContent).includes(word));
        link.hidden = !matches;
        if (matches) count++;
      });
      this.clear.disabled = this.input.value.length === 0;
      this.empty.hidden = count !== 0;
      this.count.textContent = `${count}${words.length ? ' matching' : ''} ${count === 1 ? 'topic' : 'topics'}`;
    }
    disconnectedCallback() {
      if (!this.connected) return;
      this.connected = false;
      this.input.removeEventListener('input', this.onInput);
      this.input.removeEventListener('search', this.onInput);
      this.clear.removeEventListener('click', this.onClear);
      this.details.removeEventListener('toggle', this.onToggle);
      this.removeEventListener('keydown', this.onKey);
    }
  });
})();
